import { parseNavigationConfig } from "@ghm/domain";
import { ApiError, coalescedGet, http, invalidateCoalescedGets } from "@/lib/http";
import type { NavigationConfig } from "./types";

export async function loadNavigation(signal?: AbortSignal): Promise<NavigationConfig> {
  return parseNavigationConfig(await coalescedGet<unknown>("/api/navigation", signal));
}

export async function saveNavigation(config: NavigationConfig): Promise<NavigationConfig> {
  const saved = parseNavigationConfig(await http.put<unknown>("/api/navigation", config));
  invalidateCoalescedGets(path => path === "/api/navigation");
  return saved;
}

export function navigationError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 409) return "A organização foi alterada por outra pessoa. Recarregue antes de salvar novamente.";
    if (error.status === 403) return "Você não tem permissão para organizar esta navegação.";
    if (error.body && typeof error.body === "object" && "message" in error.body && typeof error.body.message === "string") {
      return error.body.message;
    }
  }
  return "Não foi possível carregar ou salvar a organização do menu. Tente novamente.";
}
